import script from "./ManageProjectPlansPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageProjectPlansPage.vue?vue&type=script&setup=true&lang=ts"

import "./ManageProjectPlansPage.vue?vue&type=style&index=0&id=f4ad98ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4ad98ac"]])

export default __exports__